import {
  StyleSheet,
  Text,
  View,
  Image,
  ScrollView,
  TouchableOpacity,
} from "react-native";
import React, { useState } from "react";
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  useDeviceSize,
} from "rn-responsive-styles";
import { AppColors } from "../../../../utility/AppColors";
import { CommonButton } from "../../../../common/CommonButton";
import { AppFontStyle } from "../../../../styles/AppFontStyle";
import { AppImages } from "../../../../utility/AppImages";
import { StackActions, useNavigation } from "@react-navigation/native";
import { navigateToScreen } from "../../../../utility/NavigationHelper";
import { AppScreens } from "../../../Utility/AppScreens";
import { MobileDeviceNavigationHeader } from "../Common/MobileDeviceNavigationHeader";
import Header from "../Common/Header";
import { ScreenBGGradientView } from "../../../../common/CommonView";

export default function OnGoingEventsStreamingSetup() {
  const styles = useStyles();
  const deviceSize = useDeviceSize();
  const navigation = useNavigation();
  const [selectedIntegrationButton, setSelectedIntegrationButton] =
    useState("Connect");
  return (
    <View
      style={{
        flex: 1,
      }}
    >
      <ScreenBGGradientView />
      {/* Mobile Device navigation Header */}
      {/* {deviceSize === DEVICE_SIZES.XS ? (
        <MobileDeviceNavigationHeader
          btnNotificationTapped={() => {
            navigateToScreen(navigation, AppScreens.NotificationScreen
                // { txtSearch: searchEvent });
          }}
          btnSettingTapped={() => {
            navigateToScreen(navigation, AppScreens.SettingWebScreen
                // { txtSearch: searchEvent });
          }}
          btnSearchTapped={() => {
            navigateToScreen(navigation, AppScreens.SearchEventWebScreen
                // { txtSearch: searchEvent });
          }}
        />
      ) : null} */}
      <Header
        btnSearchTapped={() => {
          navigateToScreen(navigation, AppScreens.SearchEventWebScreen);
        }}
        btnWalletTapped={() => {}}
        btnStartTutorialTapped={() => {}}
        btnMessageTapped={() => {}}
        btnNotificationTapped={() => {}}
        btnProfileTapped={() => {}}
      />

      <ScrollView style={styles.container}>
        <Text
          style={[
            deviceSize === DEVICE_SIZES.EXTRA_LARGE_DEVICE
              ? AppFontStyle.BOLD_ANYBODY_32
              : AppFontStyle.BOLD_ANYBODY_24,
            { marginTop: 10 },
          ]}
        >
          Streaming Setup
        </Text>
        <Text
          style={[
            deviceSize === DEVICE_SIZES.EXTRA_LARGE_DEVICE
              ? AppFontStyle.REGULAR_ANYBODY_14
              : AppFontStyle.REGULAR_ANYBODY_12,
            {
              color: AppColors.gray_C3C3C3,
              marginHorizontal: 10,
              marginTop: 20,
            },
          ]}
        >
          Integration with External Streaming Services
        </Text>

        <View style={[styles.integrationView, {}]}>
          <View
            style={{
              flexDirection: "row",
              justifyContent: "space-between",
              backgroundColor: AppColors.gray_1E1E1E,
              borderRadius: 10,
              marginVertical: 10,
              height: 68,
            }}
          >
            <Text
              style={[
                AppFontStyle.REGULAR_ANYBODY_18,
                {
                  margin: 5,
                  color: AppColors.gray_C3C3C3,
                  alignSelf: "center",
                  paddingHorizontal: 10,
                },
              ]}
            >
              YouTube
            </Text>
            <CommonButton
              title="Connect"
              onTap={() => {
                setSelectedIntegrationButton("Connect");
              }}
              buttonStyle={
                selectedIntegrationButton == "Connect"
                  ? styles.btnStyle
                  : styles.btnComingSoonStyle
              }
              textStyle={[AppFontStyle.BOLD_ANYBODY_12, {}]}
            />
          </View>

          <View
            style={{
              flexDirection: "row",
              justifyContent: "space-between",
              backgroundColor: AppColors.gray_1E1E1E,
              borderRadius: 10,
              marginVertical: 10,
              height: 68,
            }}
          >
            <Text
              style={[
                AppFontStyle.REGULAR_ANYBODY_18,
                {
                  margin: 5,
                  color: AppColors.gray_C3C3C3,
                  alignSelf: "center",
                  paddingHorizontal: 10,
                },
              ]}
            >
              Twitch
            </Text>
            <CommonButton
              title="Coming soon"
              onTap={() => {
                setSelectedIntegrationButton("Coming soon");
              }}
              buttonStyle={
                selectedIntegrationButton == "Coming soon"
                  ? styles.btnStyle
                  : styles.btnComingSoonStyle
              }
              textStyle={[AppFontStyle.BOLD_ANYBODY_12, {}]}
            />
          </View>

          <View
            style={{
              flexDirection: "row",
              justifyContent: "space-between",
              backgroundColor: AppColors.gray_1E1E1E,
              borderRadius: 10,
              marginVertical: 10,
              height: 68,
            }}
          >
            <Text
              style={[
                AppFontStyle.REGULAR_ANYBODY_18,
                {
                  margin: 5,
                  color: AppColors.gray_C3C3C3,
                  alignSelf: "center",
                  paddingHorizontal: 10,
                },
              ]}
            >
              Esquadifi
            </Text>
            <CommonButton
              title="Connect"
              onTap={() => {
                setSelectedIntegrationButton("Connect");
              }}
              buttonStyle={
                selectedIntegrationButton == "Connect"
                  ? styles.btnStyle
                  : styles.btnComingSoonStyle
              }
              textStyle={[AppFontStyle.BOLD_ANYBODY_12, {}]}
            />
          </View>
        </View>
        <Text
          style={[
            deviceSize === DEVICE_SIZES.EXTRA_LARGE_DEVICE
              ? AppFontStyle.REGULAR_ANYBODY_14
              : AppFontStyle.REGULAR_ANYBODY_14,
            {
              color: AppColors.gray_C3C3C3,
              marginHorizontal: 10,
              marginTop: 20,
            },
          ]}
        >
          Instructions
        </Text>
        <View style={[styles.instructionView, {}]}>
          <View
            style={{
              flexDirection: "row",
              justifyContent: "space-between",
              backgroundColor: AppColors.gray_1E1E1E,
              borderRadius: 10,
              marginVertical: 10,
            }}
          >
            <Text
              style={[
                AppFontStyle.REGULAR_ANYBODY_18,
                {
                  color: AppColors.gray_C3C3C3,
                  alignSelf: "center",
                  paddingHorizontal: 10,
                  paddingVertical: 10,
                },
              ]}
            >
              Enter Server Details
            </Text>
            <Image
              source={AppImages.arrowDown}
              style={{
                height: 9,
                width: 19,
                alignSelf: "center",
                marginHorizontal: 15,
              }}
              resizeMode="contain"
            />
          </View>

          <View
            style={{
              flexDirection: "row",
              justifyContent: "space-between",
              backgroundColor: AppColors.gray_1E1E1E,
              borderRadius: 10,
              marginVertical: 10,
            }}
          >
            <Text
              style={[
                AppFontStyle.REGULAR_ANYBODY_18,
                {
                  color: AppColors.gray_C3C3C3,
                  alignSelf: "center",
                  paddingHorizontal: 10,
                  paddingVertical: 10,
                },
              ]}
            >
              Adjust Bitrate and Quality
            </Text>
            <Image
              source={AppImages.arrowDown}
              style={{
                height: 9,
                width: 19,
                alignSelf: "center",
                marginHorizontal: 15,
              }}
              resizeMode="contain"
            />
          </View>

          <View
            style={{
              flexDirection: "row",
              justifyContent: "space-between",
              backgroundColor: AppColors.gray_1E1E1E,
              borderRadius: 10,
              marginVertical: 10,
            }}
          >
            <Text
              style={[
                AppFontStyle.REGULAR_ANYBODY_18,
                {
                  color: AppColors.gray_C3C3C3,
                  alignSelf: "center",
                  paddingHorizontal: 10,
                  paddingVertical: 10,
                },
              ]}
            >
              Adjust Bitrate and Quality
            </Text>
            <Image
              source={AppImages.arrowDown}
              style={{
                height: 9,
                width: 19,
                alignSelf: "center",
                marginHorizontal: 15,
              }}
              resizeMode="contain"
            />
          </View>

          <View
            style={{
              flexDirection: "row",
              justifyContent: "space-between",
              backgroundColor: AppColors.gray_1E1E1E,
              borderRadius: 10,
              marginVertical: 10,
            }}
          >
            <Text
              style={[
                AppFontStyle.REGULAR_ANYBODY_18,
                {
                  color: AppColors.gray_C3C3C3,
                  alignSelf: "center",
                  paddingHorizontal: 10,
                  paddingVertical: 10,
                },
              ]}
            >
              Adjust Bitrate and Quality
            </Text>
            <Image
              source={AppImages.arrowDown}
              style={{
                height: 9,
                width: 19,
                alignSelf: "center",
                marginHorizontal: 15,
              }}
              resizeMode="contain"
            />
          </View>

          <View
            style={{
              flexDirection: "row",
              justifyContent: "space-between",
              backgroundColor: AppColors.gray_1E1E1E,
              borderRadius: 10,
              marginVertical: 10,
            }}
          >
            <Text
              style={[
                AppFontStyle.REGULAR_ANYBODY_18,
                {
                  color: AppColors.gray_C3C3C3,
                  alignSelf: "center",
                  paddingHorizontal: 10,
                  paddingVertical: 10,
                },
              ]}
            >
              Adjust Bitrate and Quality
            </Text>
            <Image
              source={AppImages.arrowDown}
              style={{
                height: 9,
                width: 19,
                margin: 5,
                alignSelf: "center",
                marginHorizontal: 15,
              }}
              resizeMode="contain"
            />
          </View>
        </View>
        <View style={{ flexDirection: "row", flex: 1, gap: 30 }}>
          <TouchableOpacity
            onPress={() => {
              navigation.dispatch(StackActions.pop());
            }}
            style={[
              styles.btnBackStyle,
              {
                backgroundColor: "transparent",
                borderColor: AppColors.black,
                borderWidth: 1,

                //  backgroundColor: selectedButton === 'Back' ? AppColors.appViolentColor_6D08C3 : AppColors.black_121212,
              },
            ]}
          >
            <Text
              style={[AppFontStyle.BOLD_ANYBODY_12, { marginVertical: 14 }]}
            >
              Back
            </Text>
          </TouchableOpacity>

          <TouchableOpacity
            onPress={() => {
              // setSelectedButton('Start')
            }}
            style={[
              styles.btnStartStyle,
              {
                backgroundColor: AppColors.appViolentColor_6D08C3,
                // backgroundColor: selectedButton === 'Start' ? AppColors.appViolentColor_6D08C3 : AppColors.black_121212,
              },
            ]}
          >
            <Text
              style={[AppFontStyle.BOLD_ANYBODY_12, { marginVertical: 14 }]}
            >
              Start
            </Text>
          </TouchableOpacity>
        </View>
      </ScrollView>
    </View>
  );
}

const useStyles = CreateResponsiveStyle(
  {
    container: {
      flex: 1,
      paddingHorizontal: "3.5%",
      paddingTop: "2.5%",
    },
    integrationView: {
      marginTop: 20,
      marginHorizontal: 10,
      width: 536,
    },
    instructionView: {
      marginHorizontal: 10,
      width: 517,
    },
    btnStyle: {
      paddingVertical: 0,
      paddingHorizontal: 10,
      backgroundColor: AppColors.appViolentColor_6D08C3,
      shadowOpacity: 0,
      height: 40,
      // borderRadius: 0,
      width: "27%",
      margin: 10,
    },
    btnComingSoonStyle: {
      paddingVertical: 0,
      paddingHorizontal: 10,
      backgroundColor: AppColors.gray_7B7B7B,
      shadowOpacity: 0,
      height: 40,
      borderRadius: 10,
      width: "27%",
      margin: 10,
    },
    btnStartStyle: {
      paddingVertical: 0,
      paddingHorizontal: 98,
      backgroundColor: AppColors.appViolentColor_6D08C3,
      shadowOpacity: 0,
      height: 40,
      borderRadius: 10,
      margin: 10,
    },
    btnBackStyle: {
      paddingVertical: 0,
      paddingHorizontal: 98,
      backgroundColor: AppColors.appViolentColor_6D08C3,
      shadowOpacity: 0,
      height: 40,
      borderRadius: 10,
      margin: 10,
    },
    deviceflexDirection: {
      flexDirection: "row",
    },
  },
  {
    [DEVICE_SIZES.MD]: {
      container: {
        flex: 1,
        paddingHorizontal: "3.5%",
        paddingTop: "2.5%",
      },
      integrationView: {
        marginTop: 20,
        marginHorizontal: 10,
        width: "100%",
        // alignSelf: "flex-start",
        // flex:1
      },
      instructionView: {
        marginHorizontal: 10,
        width: "100%",
      },
      btnComingSoonStyle: {
        paddingVertical: 0,
        paddingHorizontal: 10,
        backgroundColor: AppColors.gray_7B7B7B,
        shadowOpacity: 0,
        height: 40,
        borderRadius: 10,
        width: "30%",
        margin: 10,
      },
      btnStyle: {
        paddingVertical: 0,
        paddingHorizontal: 10,
        backgroundColor: AppColors.appViolentColor_6D08C3,
        shadowOpacity: 0,
        height: 40,
        borderRadius: 15,
        width: "30%",
        margin: 10,
      },
      btnStartStyle: {
        paddingVertical: 0,
        paddingHorizontal: 90,
        backgroundColor: AppColors.appViolentColor_6D08C3,
        shadowOpacity: 0,
        height: 40,
        borderRadius: 10,
        margin: 10,
      },
      btnBackStyle: {
        paddingVertical: 0,
        paddingHorizontal: 90,
        backgroundColor: AppColors.appViolentColor_6D08C3,
        shadowOpacity: 0,
        height: 40,
        borderRadius: 10,
        margin: 10,
      },
      deviceflexDirection: {
        flexDirection: "row",
      },
    },
    [DEVICE_SIZES.LG]: {
      container: {
        flex: 1,
        paddingHorizontal: "3.5%",
        paddingTop: "2.5%",
      },
      integrationView: {
        marginTop: 20,
        marginHorizontal: 10,
        width: "100%",
        // alignSelf: "flex-start",
        // flex:1
      },
      instructionView: {
        marginHorizontal: 10,
        width: "100%",
      },
      btnComingSoonStyle: {
        paddingVertical: 0,
        paddingHorizontal: 10,
        backgroundColor: AppColors.gray_7B7B7B,
        shadowOpacity: 0,
        height: 40,
        borderRadius: 10,
        width: "30%",
        margin: 10,
      },
      btnStyle: {
        paddingVertical: 0,
        paddingHorizontal: 10,
        backgroundColor: AppColors.appViolentColor_6D08C3,
        shadowOpacity: 0,
        height: 40,
        borderRadius: 15,
        width: "30%",
        margin: 10,
      },
      btnStartStyle: {
        paddingVertical: 0,
        paddingHorizontal: 95,
        backgroundColor: AppColors.appViolentColor_6D08C3,
        shadowOpacity: 0,
        height: 40,
        borderRadius: 10,
        margin: 10,
      },
      btnBackStyle: {
        paddingVertical: 0,
        paddingHorizontal: 95,
        backgroundColor: AppColors.appViolentColor_6D08C3,
        shadowOpacity: 0,
        height: 40,
        borderRadius: 10,
        margin: 10,
      },
      deviceflexDirection: {
        flexDirection: "row",
      },
    },
    [DEVICE_SIZES.EXTRA_LARGE_DEVICE]: {
      container: {
        flex: 1,
        paddingHorizontal: "3.5%",
        paddingTop: "2.5%",
      },
      integrationView: {
        marginTop: 20,
        marginHorizontal: 10,
        width: 536,
        // alignSelf: "flex-start",
        // flex:1
      },
      btnComingSoonStyle: {
        paddingVertical: 0,
        paddingHorizontal: 10,
        backgroundColor: AppColors.gray_7B7B7B,
        shadowOpacity: 0,
        height: 40,
        borderRadius: 10,
        width: "27%",
        margin: 10,
      },
      instructionView: {
        marginHorizontal: 10,
        width: 517,
        // alignSelf: "flex-start",
      },
      btnStyle: {
        paddingVertical: 0,
        paddingHorizontal: 10,
        backgroundColor: AppColors.appViolentColor_6D08C3,
        shadowOpacity: 0,
        height: 40,
        borderRadius: 15,
        width: "27%",
        margin: 10,
      },
      btnStartStyle: {
        paddingVertical: 0,
        paddingHorizontal: 98,
        backgroundColor: AppColors.appViolentColor_6D08C3,
        shadowOpacity: 0,
        height: 40,
        borderRadius: 10,
        margin: 10,
      },
      btnBackStyle: {
        paddingVertical: 0,
        paddingHorizontal: 98,
        backgroundColor: AppColors.appViolentColor_6D08C3,
        shadowOpacity: 0,
        height: 40,
        borderRadius: 10,
        margin: 10,
      },
      deviceflexDirection: {
        flexDirection: "row",
      },
    },
    [DEVICE_SIZES.SM]: {
      container: {
        flex: 1,
        paddingHorizontal: "3.5%",
        paddingTop: "2.5%",
      },
      integrationView: {
        marginTop: 20,
        marginHorizontal: 10,
        width: "100%",
        // alignSelf: "flex-start",
        // flex:1
      },
      instructionView: {
        marginHorizontal: 10,
        width: "100%",
      },
      btnComingSoonStyle: {
        paddingVertical: 0,
        paddingHorizontal: 10,
        backgroundColor: AppColors.gray_7B7B7B,
        shadowOpacity: 0,
        height: 40,
        borderRadius: 10,
        width: "30%",
        margin: 10,
      },
      btnStyle: {
        paddingVertical: 0,
        paddingHorizontal: 10,
        backgroundColor: AppColors.appViolentColor_6D08C3,
        shadowOpacity: 0,
        height: 40,
        borderRadius: 15,
        width: "30%",
        margin: 10,
      },
      btnStartStyle: {
        paddingVertical: 0,
        paddingHorizontal: 80,
        backgroundColor: AppColors.appViolentColor_6D08C3,
        shadowOpacity: 0,
        height: 40,
        borderRadius: 10,
        margin: 10,
      },
      btnBackStyle: {
        paddingVertical: 0,
        paddingHorizontal: 80,
        backgroundColor: AppColors.appViolentColor_6D08C3,
        shadowOpacity: 0,
        height: 40,
        borderRadius: 10,
        margin: 10,
      },
      deviceflexDirection: {
        flexDirection: "row",
      },
    },
    [DEVICE_SIZES.XS]: {
      container: {
        flex: 1,
        paddingHorizontal: "3.5%",
        paddingTop: "2.5%",
      },
      integrationView: {
        marginTop: 20,
        marginHorizontal: 10,
        width: "100%",
        // alignSelf: "flex-start",
        // flex:1
      },
      instructionView: {
        marginHorizontal: 10,
        width: "100%",
      },
      btnComingSoonStyle: {
        paddingVertical: 0,
        paddingHorizontal: 10,
        backgroundColor: AppColors.gray_7B7B7B,
        shadowOpacity: 0,
        height: 40,
        borderRadius: 10,
        width: "30%",
        margin: 10,
      },
      btnStyle: {
        paddingVertical: 0,
        paddingHorizontal: 10,
        backgroundColor: AppColors.appViolentColor_6D08C3,
        shadowOpacity: 0,
        height: 40,
        borderRadius: 15,
        width: "30%",
        margin: 10,
      },
      btnStartStyle: {
        paddingVertical: 0,
        paddingHorizontal: 50,
        backgroundColor: AppColors.appViolentColor_6D08C3,
        shadowOpacity: 0,
        height: 40,
        borderRadius: 10,
        margin: 10,
      },
      btnBackStyle: {
        paddingVertical: 0,
        paddingHorizontal: 50,
        backgroundColor: AppColors.appViolentColor_6D08C3,
        shadowOpacity: 0,
        height: 40,
        borderRadius: 10,
        margin: 10,
      },
      deviceflexDirection: {
        flexDirection: "row",
      },
    },
  }
);
